const messages = {
    en: {
        role: {
            permissions: {
                METHOD_SHOW: "View payment method",
                METHOD_UPDATE: "Modify payment method",
                METHOD_CREATE: "Create payment method",
                METHOD_DELETE: "Delete payment method"
            }
        }
    },
    es: {
        role: {
            permissions: {
                METHOD_SHOW: "Ver método de pago",
                METHOD_UPDATE: "Modificar método de pago",
                METHOD_CREATE: "Crear método de pago",
                METHOD_DELETE: "Eliminar método de pago"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                METHOD_SHOW: "Ver método de pagamento",
                METHOD_UPDATE: "Modificar método de pagamento",
                METHOD_CREATE: "Criar método de pagamento",
                METHOD_DELETE: "Eliminar método de pagamento"
            }
        }
    }
}

export default messages
